<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title v-if="numcliente == '' || numcliente == null">
                        <v-icon large left>mdi-excavator</v-icon>
                        Listado Completo de Obras
                        <v-spacer></v-spacer>
                        <v-btn icon @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-title v-if="numcliente != '' && numcliente != null">
                        <v-icon large left>mdi-excavator</v-icon>
                        Listado de Obras del Cliente N° {{ numcliente }} - {{ nomcliente }}
                        <v-spacer></v-spacer>
                        <v-btn icon @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="pt-2">
                        <v-row dense>
                            <v-col cols="12" sm="8" md="6">
                                <v-text-field dense v-model="filtroobra" label="Filtrar por Nombre de Obra">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="3">
                                <v-btn color="success" @click.stop="cargardatos()">Buscar</v-btn>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-dialog v-model="dialog" persistent max-width="600px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" v-if="numcliente != '' && numcliente != null" dark
                                        v-bind="attrs" v-on="on" @click="cargarnumobra()">
                                        Nuevo Obra
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="text-h5">Nueva Obra N°: {{ numobra }}
                                            <p> Cliente N° {{ numcliente }} - {{ nomcliente }}
                                            </p>
                                            <p> N° SGI IN-{{ numsgi }}
                                            </p>
                                        </span>
                                    </v-card-title>
                                    <v-card-text style="overflow: auto;">
                                        <v-container>
                                            <v-row dense>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field dense label="Nombre de la Obra"
                                                        v-model="nomobra"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-text-field dense v-model="fecha" label="Fecha"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-select dense v-model="responsable" label="Responsable"
                                                        :items="listadoresp" item-text="nombre"
                                                        item-value="nombre"></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-select dense v-model="fabelec" label="Responsable Fab. Elec."
                                                        :items="listadoresp" item-text="nombre" item-value="nombre"
                                                        class="pa-0 ma-0"></v-select>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-select dense v-model="fabmec" label="Responsable Fab. Mec."
                                                        :items="listadoresp" item-text="nombre" item-value="nombre"
                                                        class="pa-0 ma-0"></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field dense v-model="numicssa"
                                                        label="N° ICSSA"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="show = false">
                                            Cerrar
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="guardarobra()">
                                            Guardar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                        :items-per-page="200" :footer-props="{
                            itemsPerPageText: 'Obras por página',
                        }">
                        <template v-slot:item.numsgi="{ item }">
                            IN-{{ item.numsgi }}
                        </template>
                        <template v-slot:item.estado="{ item }">
                            {{ item.estado === 'T' ? 'Archivada' : 'Curso' }}
                        </template>
                        <!-- <template v-if="item.estado == 'T'" v-slot:item.estado="{ item }">
                            Archivada
                        </template> -->
                        <template v-slot:item.actions="{ item }">
                            <!-- <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs"
                                    @click.stop="ver(item)">
                                    mdi-eye
                                </v-icon>
                            </template>
        <span>ver obras</span>
        </v-tooltip> -->
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                        @click.stop="editar(item)">
                                        mdi-pencil
                                    </v-icon>
                                </template>
                                <span>agregar obra</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
                <Editar :visible="showEditar" :numcliente="editedItem.numcliente" :numobra="editedItem.numobra"
                    @close="showEditar = false">
                </Editar>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
    display: none;
}
</style>

<script>
import axios from "../../../axios-auth";
import moment from "moment";
import Editar from "./Editarobra.vue";
export default {
    components: { Editar },
    data: (vm) => ({
        showEditar: false,
        editedItem: {},
        editedIndex: -1,
        filtroobra: "",
        numobra: "",
        nomobra: "",
        numsgi: "",
        responsable: "",
        fabelec: "",
        fabmec: "",
        fecha: moment().format("DD/MM/YYYY"),
        numicssa: "",
        listadoresp: [],
        codigo: "",
        clientes: [],
        listado: [],
        dialog: false,
        obrasactivas: false,
        headers: [
            { text: "N° SGI", align: "center", sortable: false, value: "numsgi" },
            { text: "N° Cliente", align: "center", sortable: false, value: "numcliente" },
            { text: "N° Obra", align: "center", sortable: false, value: "numobra" },
            { text: "Obra", value: "nomobra" },
            { text: "Responsable", align: "center", sortable: false, value: "responsable" },
            { text: "Responsable Fab. Elec.", align: "center", sortable: false, value: "fabelec" },
            { text: "Responsable Fab. Mec.", align: "center", sortable: false, value: "fabmec" },
            { text: "Fecha", align: "center", sortable: false, value: "fecha" },
            { text: "Estado", align: "center", sortable: false, value: "estado" },
            { text: "Acciones", align: "center", sortable: false, value: "actions" },
        ],
    }),
    props: ["visible", "numcliente", "nomcliente"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos()
                    this.cargarnumsgi()
                    this.cargarnumobra()
                    this.cargarresponsable()
                }
                //this.cargardatos(false);
                return this.visible;
            },
            set(value) {
                if (!value) {
                    // this.$refs.form.resetValidation();
                    //this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargardatos() {
            let self = this;
            let filtroobra = this.filtroobra;
            let filtrocliente = this.numcliente;
            axios
                .get("/Ingenieria/Listadoobras", {
                    params: {
                        filtroobra: filtroobra,
                        filtrocliente: filtrocliente,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    self.listado = [];
                });
        },

        cargarnumobra() {
            let self = this;
            let numcliente = this.numcliente;
            axios
                .get("/Ingenieria/CodigoObra", {
                    params: {
                        numcliente: numcliente
                    }
                })
                .then((response) => {
                    self.numobra = response.data;
                })
                .catch((error) => {
                    self.numobra = "";
                });
        },

        cargarnumsgi() {
            let self = this;
            axios
                .get("/Ingenieria/CodigoSGI", {
                })
                .then((response) => {
                    self.numsgi = response.data;
                })
                .catch((error) => {
                    self.numsgi = "";
                });
        },
        cargarresponsable() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoproyectistas", {
                })
                .then((response) => {
                    self.listadoresp = response.data;
                })
                .catch((error) => {
                    self.listadoresp = [];
                });
        },

        guardarobra() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Cliente",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        numcliente: this.numcliente,
                        nomobra: this.nomobra,
                        numobra: this.numobra,
                        numsgi: this.numsgi,
                        numicssa: this.numicssa,
                        responsable: this.responsable,
                        fabelec: this.fabelec,
                        fabmec: this.fabmec,
                        fecha: this.fecha,

                    };

                    let self = this;
                    axios
                        .post("/Ingenieria/GuardarObra", datos)
                        .then((response) => {
                            self.showAlert({
                                icon: "success",
                                title: "Obra guardada con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            setTimeout(() => {
                                self.$router.push({ name: "IngListadoCliente" });
                            }, 2000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        vaciarListado() {
            this.listado = [];
            this.codigo = "";
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 1500,
            });
        },
        editar(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },
    },
};
</script>